var map = {
	"./2020/AL.jpg": 32,
	"./2020/AP.jpg": 33,
	"./2020/BA.jpg": 34,
	"./2020/DF.jpg": 35,
	"./2020/GO.jpg": 36,
	"./2020/MA.jpg": 37,
	"./2020/MG.jpg": 38,
	"./2020/MS.jpg": 39,
	"./2020/PA.jpg": 40,
	"./2020/PI.jpg": 41,
	"./2020/PR.jpg": 42,
	"./2020/RJ.jpg": 43,
	"./2020/SC.jpg": 44,
	"./2020/SP.jpg": 45,
	"./2021/AM.jpg": 46,
	"./2021/CE.jpg": 47,
	"./2021/ES.jpg": 48,
	"./2021/MT.jpg": 49,
	"./2021/PB.jpg": 50,
	"./2021/PE.jpg": 51,
	"./2021/RJ.jpg": 52,
	"./2021/RN.jpg": 53,
	"./2021/RO.jpg": 54,
	"./2021/RS.jpg": 55,
	"./2021/SE.jpg": 56,
	"./2021/SP.jpg": 57,
	"./2021/TO.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;